import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CookiesManagerService {
  constructor(private cookieService: CookieService) {}

  // Get the base domain
  private getCookieDomain(): string | undefined {
    const hostname = window.location.hostname;

    if (hostname === 'localhost') {
      return undefined; // No domain for localhost
    }

    const parts = hostname.split('.');

    // If more than 2 parts (subdomain), return the base domain (.diktup.cloud)
    if (parts.length > 2) {
      return `.${parts.slice(-2).join('.')}`; // .diktup.cloud for subdomains
    }

    // If exactly 2 parts (main domain), return the full hostname (diktup.cloud)
    return hostname; // e.g., diktup.cloud
  }

  // Set a cookie with proper domain and path
  set(name: string, value: string): void {
    const domain = this.getCookieDomain();
    this.cookieService.set(
      name,
      value,
      undefined, // Optional expires value
      '/', // Path to ensure the cookie is accessible across the entire domain
      domain, // Domain for the base domain
      window.location.protocol === 'https:', // Secure flag based on protocol
      'Lax' // SameSite attribute for security
    );
  }

  // Get a cookie value
  get(name: string): string | null {
    return this.cookieService.get(name) || null;
  }

  // Remove a cookie
  delete(name: string): void {
    this.cookieService.delete(name, '/', undefined); // Delete for the current subdomain
    this.cookieService.delete(name, '/', this.getCookieDomain()); // Delete for the base domain
  }
}
